import Lottie from 'lottie-react';
import type { JSX } from 'react';
import animationData from '@/assets/animations/Splash.json';
import styles from './SplashScreen.module.css';

const SplashScreen = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <Lottie
        animationData={animationData}
        className={styles.Lottie}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
        }}
      />
      <div className={styles.textcontainer}>
        <span className={styles.text}>Share</span>
        <span className={styles.dot} />
        <span className={styles.text}>Shop</span>
        <span className={styles.dot} />
        <span className={styles.text}>Slay</span>
      </div>
    </div>
  );
};

export default SplashScreen;
